import React from 'react'
import { tv } from 'tailwind-variants'

// In the manner of shadcn/ui's secondary badge: a small, quiet pill of context, filled rather than outlined so
// it doesn't read as a button, and smaller than the text around it.
// `large` is for a status that stands on its own, as the value of a settings row ("Paid seat"), at the size of
// the text beside it.
const badge = tv({
  base: 'inline-flex shrink-0 items-center whitespace-nowrap rounded-full font-medium',
  variants: {
    tone: {
      muted: 'bg-surface-hover text-body',
      blue: 'bg-blue/10 text-blue'
    },
    size: {
      small: 'px-1.5 text-[11px] leading-[18px]',
      large: 'px-2.5 text-[13px] leading-6'
    }
  },
  defaultVariants: { tone: 'muted', size: 'small' }
})

/** A short note beside a label: "Paid seat required" in grey, "Current" in blue. */
const Badge: React.FC<{
  tone?: 'muted' | 'blue'
  size?: 'small' | 'large'
  id?: string
  children: React.ReactNode
}> = ({ tone, size, id, children }) => (
  <span id={id} className={badge({ tone, size })}>
    {children}
  </span>
)

export default Badge
